export default "<div class=\"no-access\">\r\n    <img src=\"assets/images/no-access.png\" alt=\"\">\r\n</div>"